// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RFcM","buttons":"styles_buttons__36r7K"};